const Images = {
    Images:[
        {
            id:1,
            path:'fototeam.webp',
            alt:'BCS team group photo'
        },
        {
            id:2,
            path:'fotowed1.webp',
            alt:'Wedding ceremony documentation'
        },
        {
            id:3,
            path:'fotowed2.webp',
            alt:'Wedding reception celebration'
        },
        {
            id:4,
            path:'Wedding-Ryan-1.webp',
            alt:'Professional team collaboration'
        },
        {
            id:5,
            path:'Wedding-Ryan-2.webp',
            alt:'Wedding venue setup and decoration'
        },
        {
            id:6,
            path:'Wedding-Ryan-3.webp',
            alt:'Traditional wedding ceremony moment'
        },
        {
            id:7,
            path:'weddingbaru1.webp',
            alt:'Outdoor wedding ceremony arrangement'
        },
        {
            id:8,
            path:'weddingbaru2.webp',
            alt:'Wedding photography session'
        },
        {
            id:9,
            path:'weddingbaru3.webp',
            alt:'Wedding celebration with guests'
        }
    ]
}
export default Images
